export default {
  tagImg: {
    src: "/static/img/button/pm.png"
  },
  tagText: "Project Management",
  link: ""
};
